import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "w-full border rounded-lg border-neutral-100" }
const _hoisted_5 = { class: "relative overflow-auto" }
const _hoisted_6 = { class: "absolute left-0 top-0 h-full whitespace-nowrap position w-[181px] shadow-[2px_0_16px_0px_rgb(0,0,0,0.08)]" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-[26px] bg-primary-100 text-sm font-semibold relative" }, "Settings", -1)
const _hoisted_8 = { class: "pl-[181px] w-[calc(100vw-224px)]" }
const _hoisted_9 = { class: "flex items-center justify-between p-6 border-b border-neutral-100" }
const _hoisted_10 = { class: "flex items-center space-x-4" }
const _hoisted_11 = {
  key: 0,
  class: "flex items-start p-3 space-x-3 overflow-auto side-scroll"
}
const _hoisted_12 = { class: "flex items-start space-x-3" }
const _hoisted_13 = {
  key: 0,
  class: "border border-neutral-100 rounded-lg w-[320px]"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "p-6 border-b border-neutral-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-neutral-400" }, "Intervention Type")
], -1)
const _hoisted_15 = { class: "flex-1 pr-6 overflow-hidden whitespace-nowrap text-ellipsis" }
const _hoisted_16 = { class: "flex items-center space-x-2 shrink-0" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_19 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_20 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_21 = { class: "flex items-center justify-center mx-auto" }
const _hoisted_22 = {
  key: 2,
  class: "w-full px-6 border-t py-7"
}

import { ref, computed, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import RestoreButton from "@/components/buttons/RestoreButton.vue";
import DataTable from "../Components/DataTable.vue";
import SideTab from "../Components/SideTab.vue";
import MinifyPagination from "@/components/partials/MinifyPagination.vue";
import TabComponent from "@/components/partials/TabComponent.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import { PlusIcon } from "@heroicons/vue/24/outline";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import PrimaryDiagnosisService from "@/classes/Settings/PrimaryDiagnosisService";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import ActivityLogsTable from "@/views/activity-logs/ActivityLogsTable.vue";
import { ChevronRightIcon, EyeIcon } from "@heroicons/vue/24/outline";
import DateFormatter from "@/helpers/DateFormatter";

import InterventionTypeService from "@/classes/Settings/InterventionTypeService.ts"

import FormsCard from "@/views/settings/InterventionTypes/Components/Index/FormsCard.vue";

import { FormInterface } from "@/interfaces/pages/Settings/InterventionFormInterface.ts";



export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
/**
 * VARIABLES
 */
const tab = ref<any>(route.query.tab);
const items = ref<any>(null);
const filterSearch = ref<any>(route.query.query);
const page = ref<any>(route.query.page);
const lastPage = ref<any>(null);
const rows = ref<any>(route.query.rows || 10);
const numRows = computed(() => (rows.value ? rows.value + " Rows" : "All"));
const showRestoreConfirmation = ref<boolean>(false);
const showRestoreSuccess = ref<boolean>(false);
const selectedForm = ref<number>(0);
const activityLogs = ref<any>({});

const loaded = ref<boolean>(false);

const activeForm = ref<FormInterface>({
	id: 0,
	label: '',
	order: 0,
});

const subForms = ref<FormInterface[]>([]);

const tabs = ref<{ name: string; count: number; tab: string|null; href: string; allowed: boolean }[]>([
	{
		name: "All",
		count: 0,
		tab: null,
		href: "/settings/intervention-types/index",
		allowed: true,
	},
	{
		name: "Archived",
		count: 0,
		tab: "archived",
		href: "/settings/intervention-types/index?tab=archived",
		allowed: true,
	},
	{
		name: "Activity logs",
		count: 0,
		tab: "activity_logs",
		href: "/settings/intervention-types/index?tab=activity_logs",
		allowed: true,
	},
]);

const headers: { text: string; haveSort?: boolean }[] = [{ text: "Form Title" }, { text: "Date Deleted" }];

/**
 * METHODS
 */
const getData = (search: any = null): void => {
	InterventionTypeService
		.index(
			pickBy({
				query: search ?? filterSearch.value,
				page: page.value,
				rows: rows.value,
				tab: tab.value,
			})
		)
		.then((response: any) => {
			items.value = response.data.items;

			tabs.value = [
				{
					name: "All",
					count: response.data.allItemsCount,
					tab: null,
					href: "/settings/intervention-types/index",
					allowed: true,
				},
				{
					name: "Archived",
					count: response.data.archiveItemsCount,
					tab: "archived",
					href: "/settings/intervention-types/index?tab=archived",
					allowed: true,
				},
				{
					name: "Activity logs",
					count: response.data.activityLogsCount,
					tab: "activity_logs",
					href: "/settings/intervention-types/index?tab=activity_logs",
					allowed: true,
				},
            ]
		})
		.catch((error: any) => {
			console.log(error);
		});
};

const getSubForm = (form: FormInterface):void => {

	activeForm.value = form
	loaded.value = false

	InterventionTypeService
		.getChildForms(form.id)
		.then(({data}) => {
			subForms.value = data.children;
			loaded.value = true
		})
		.catch((error: any) => {
			console.log(error);
		});
}

const reloadPage = async () => {
	return await router.push({
		path: "/settings/intervention-types/index",
		query: pickBy({
			query: filterSearch.value,
			page: page.value,
			rows: rows.value,
			tab: tab.value,
		}),
	});
};

const applyFilters = (search: any = null) => {
	reloadPage().then(() => {
		getData(search);
	});
};

const changeRows = (row: any): void => {
	rows.value = row;
	applyFilters();
};

const paginate = (data: number): void => {
	page.value = data;
	applyFilters();
};

const updateTab = (currentTab: string) => {
	tab.value = currentTab;
	page.value = 1;
	applyFilters();
};

/**
 * MODALS
 */
const showRestoreModal = (item: any): void => {
	showRestoreConfirmation.value = true;
	selectedForm.value = item.id;
};

const closeRestoreModal = (): void => {
	showRestoreSuccess.value = false;
};

const restoreRecord = (): void => {

	InterventionTypeService.restore( selectedForm.value)
		.then(() => {
			showRestoreSuccess.value = true;
			showRestoreConfirmation.value = false;
			applyFilters();
		})
		.catch((error) => console.log(error));
};

/**
 * WATCHERS
 */
watch(
	filterSearch,
	throttle((val: string) => {
        page.value = 1;
		applyFilters(val);
	}, 1000)
);

watch(
	() => tab.value,
	throttle(() => {
		getData();
	}, 1000)
);

onMounted(() => {
	getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, {
            title: "Settings",
            description: "View the relevant data and other details"
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(SideTab, { interventionTypesSelected: "" })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(TabComponent, {
                      tabs: tabs.value,
                      "onUpdate:tab": _cache[0] || (_cache[0] = (value) => updateTab(value))
                    }, null, 8, ["tabs"])
                  ])
                ]),
                _createElementVNode("div", null, [
                  (_unref(route).query.tab != 'activity_logs' && _unref(route).query.tab != 'archived')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          (items.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _hoisted_14,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.data, (item) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: item.id,
                                    class: _normalizeClass(["flex items-center py-6 pl-6 pr-4 border-b last:border-0", activeForm.value.id == item.id ? 'bg-primary-300 ' : ''])
                                  }, [
                                    _createElementVNode("div", _hoisted_15, [
                                      _createElementVNode("p", {
                                        class: _normalizeClass(["overflow-hidden text-sm whitespace-nowrap text-ellipsis", activeForm.value.id == item.id ? 'text-primary-600' : 'text-neutral-900'])
                                      }, _toDisplayString(item.label), 3)
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                      _createVNode(_unref(EyeIcon), {
                                        onClick: ($event: any) => (_unref(router).replace(`/settings/intervention-types/edit/${item.id}`)),
                                        class: _normalizeClass(["w-5 h-5 transition cursor-pointer hover:text-secondary-500", activeForm.value?.id == item?.id ? 'text-primary-600' : 'text-gray-500']),
                                        "aria-hidden": "true"
                                      }, null, 8, ["onClick", "class"]),
                                      _createVNode(_unref(ChevronRightIcon), {
                                        class: _normalizeClass(["w-5 h-5 transition cursor-pointer", activeForm.value.id == item.id ? 'text-primary-600' : 'text-gray-500 hover:text-primary-500']),
                                        "aria-hidden": "true",
                                        onClick: ($event: any) => (getSubForm(item))
                                      }, null, 8, ["class", "onClick"])
                                    ])
                                  ], 2))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (loaded.value)
                            ? (_openBlock(), _createBlock(FormsCard, {
                                key: 1,
                                form: activeForm.value,
                                subForms: subForms.value
                              }, null, 8, ["form", "subForms"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_unref(route).query.tab == 'archived')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(DataTable, {
                        headers: headers,
                        "no-action": false,
                        count: items.value?.total,
                        "onUpdate:searchText": _cache[1] || (_cache[1] = (value) => (filterSearch.value = value)),
                        tableClass: "header-frm-table"
                      }, {
                        body: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.data, (item) => {
                            return (_openBlock(), _createElementBlock("tr", { key: item }, [
                              _createElementVNode("td", _hoisted_18, _toDisplayString(item.label), 1),
                              _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(DateFormatter).defaultTimeStamp(item?.deleted_at)), 1),
                              _createElementVNode("td", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(RestoreButton, {
                                    onClick: ($event: any) => (showRestoreModal(item))
                                  }, null, 8, ["onClick"])
                                ])
                              ])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["count"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(route).query.tab == 'activity_logs')
                  ? (_openBlock(), _createBlock(ActivityLogsTable, {
                      key: 1,
                      items: items.value
                    }, null, 8, ["items"]))
                  : _createCommentVNode("", true),
                (_unref(route).query.tab == 'archived' || _unref(route).query.tab == 'activity_logs')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(MinifyPagination, {
                        numRows: numRows.value,
                        "onUpdate:rows": _cache[2] || (_cache[2] = (value) => changeRows(value)),
                        "onUpdate:page": _cache[3] || (_cache[3] = (value) => paginate(value)),
                        "current-page": page.value,
                        "last-page": lastPage.value
                      }, null, 8, ["numRows", "current-page", "last-page"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(ConfirmationModal, {
              typeTwo: true,
              show: showRestoreConfirmation.value,
              onCancel: _cache[4] || (_cache[4] = ($event: any) => (showRestoreConfirmation.value = false)),
              onConfirm: _cache[5] || (_cache[5] = ($event: any) => (restoreRecord())),
              "cancel-text": "Cancel",
              "action-text": "Confirm",
              title: "Restore Record",
              content: "Are you sure you wish to restore this record?"
            }, null, 8, ["show"]),
            _createVNode(SuccessModal, {
              show: showRestoreSuccess.value,
              onConfirm: _cache[6] || (_cache[6] = ($event: any) => (closeRestoreModal())),
              "action-text": "Close",
              title: "Record Restored!",
              content: "Selected record has been successfully restored!"
            }, null, 8, ["show"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})